export const categories = [
  {
    key: 'corrective',
    label: 'Corrective',
  },
  {
    key: 'preventive',
    label: 'Preventive',
  },
  {
    key: 'onboarding',
    label: 'Onboarding',
  },
  {
    key: 'offboarding',
    label: 'Offboarding',
  },
];

export const types = [
  {
    key: 'inspection',
    label: 'Inspection',
  },
  {
    key: 'repair',
    label: 'Repair',
  },
  {
    key: 'maintenance',
    label: 'Maintenance',
  },
];

export const priorities = [
  {
    key: 1,
    label: 'Very Low',
  },
  {
    key: 2,
    label: 'Low',
  },
  {
    key: 3,
    label: 'Medium',
  },
  {
    key: 4,
    label: 'High',
  },
  {
    key: 5,
    label: 'Critical',
  },
];

export const impacts = [
  {
    key: 1,
    label: 'High',
  },
  {
    key: 2,
    label: 'Medium',
  },
  {
    key: 3,
    label: 'Low',
  },
];

export const executionIntervals = [
  {
    key: '1-month',
    label: 'Monthly',
  },
  {
    key: '3-months',
    label: '3 months',
  },
  {
    key: '6-months',
    label: '6 months',
  },
  {
    key: '9-months',
    label: '9 months',
  },
  {
    key: '12-months',
    label: '12 months',
  },
  {
    key: 'na',
    label: 'N/A',
  },
];

export const BLANK_TEXT = 'blank';
